import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import Select from "react-select";
import { CSVLink } from "react-csv";
import { getApiBaseUrl } from "../../utils/utils";
import jQuery from "jquery";
export default function GetDriverMedicalOrders() {
  pdfMake.vfs = pdfFonts.vfs;
  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState("");
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const $ = jQuery.noConflict();

  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");
    });
  }, []);

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };

  const [msg, setMsg] = useState("");
  const [errormsg, setError] = useState("");

  useEffect(() => {
    // Fetch drivers from the API on component mount
    fetchDrivers();
    getUserList();
  }, []);

  const [scaninfo, setScaninfo] = useState({
    driver: "",
  });
  const [drivers, setDrivers] = useState();
  const [awb, setAwb] = useState();
  const fetchDrivers = async () => {
    try {
      // Replace this API endpoint with the actual one that fetches drivers based on the emirate
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getAllDrivers`
      );

      if (response.data.success) {
        const driversData = response.data.data; // The array of driver objects

        // Map the response to extract driverId and name
        const driversList = driversData.map((driver) => ({
          driver_id: driver.driverId,
          driver_name: driver.name,
        }));

        // Set the drivers state
        setDrivers(driversList);
      } else {
        console.error("Error fetching drivers for emirate:");
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  };

  const [users, setusers] = useState();
  const getUserList = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

    // Send a GET request to the new API
    try {
      const res = await axios.get(API_PATH);

      console.log(res.data); // Log the response to inspect it

      // Check if the response contains 'data' and if it's an array
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setusers(res.data.data); // Update the personnel list in the state
      } else {
        console.log(
          "No personnel data found in the response or response is not successful"
        );
      }
    } catch (err) {
      console.log("Error fetching personnel list:", err);
    }
  };

  console.log("drivers:", drivers);
  console.log("scan:", scaninfo);
  console.log("users:", users);

  const getDetails = async () => {
    try {
      const response = await axios.get(
        `${API_URL}shypvdriverapp/jobs/getDriverReportDateRange`,
        {
          params: {
            driverId: driver,
            fromDate: datechosen,
            toDate: datechosento,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response Data:", response.data);

      // Handle response data
      if (response.data.success) {
        // const filteredData = (response.data.data || []).filter(order => order.shipmentType === 'medical').filter(order => (order.STATUS=='DELIVERED') || (order.STATUS=='PICKED_UP'));
        const filteredData = (response.data.data || []).filter(
          (order) =>
            order.shipmentType === "medical" &&
            (order.STATUS === "DELIVERED" || order.STATUS === "PICKED_UP")
        );
        setShipmentDetails(filteredData);

        fetchDriverInfo(driver);
        if (response.data.data.length === 0) {
          setError("Booking details not found");
        } else {
          setError("");
        }
      } else {
        setShipmentDetails([]);
        setError("Booking details not found");
      }
    } catch (err) {
      console.error("Error:", err.response || err.message);
      setError("An error occurred while fetching details");
    }
  };

  const [driverdata, setdriverdata] = useState({
    driverid: "",
    team: "",
    zone: "",
  });
  const fetchDriverInfo = async (driverId) => {
    try {
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getDriver`,
        {
          params: { driverId },
        }
      );

      console.log("Driver Info:", response.data);
      if (response.data.success) {
        const driverInfo = response.data.data;

        setdriverdata({
          driverid: driverInfo.driverId || "",
          team: driverInfo.team?.teamName || "",
          zone: driverInfo.zone?.emirates || "",
        });
      } else {
        setdriverdata({ driverid: driverId, team: "", zone: "" });
      }
      // Optionally update state or show UI
      // setDriverDetails(response.data);
    } catch (error) {
      console.error("Error fetching driver info:", error);
      setdriverdata({ driverid: driverId, team: "", zone: "" });
    }
  };

  const [errorNew, seterrorNew] = useState("");

  const getDriverName = (driverId) => {
    const driver = drivers.find(
      (driver) => driver.driver_id === parseInt(driverId)
    );
    return driver ? driver.driver_name : "Unknown"; // Default to 'Unknown' if not found
  };

  const getUserName = (userid) => {
    console.log("user is ", userid);
    const user = users.find((user) => user.personnel_id === parseInt(userid));

    return user ? user.personnel_name : "Unknown"; // Default to 'Unknown' if not found
  };

  const [allStatus, setallStatus] = useState();
  useEffect(() => {
    // Make the API call when the component mounts
    axios
      .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
      .then((response) => {
        setallStatus(response.data.data); // Store the data in state
        setLoading(false); // Set loading to false when done
      })
      .catch((err) => {
        setError(err); // Store the error in state if something goes wrong
        setLoading(false); // Set loading to false even if there's an error
      });
  }, []);

  console.log("all", allStatus);

  //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
  const [newStatus, setnewStatus] = useState(0);
  // Handle status change
  const handleStatusChange = (index, newStatus) => {
    setnewStatus(newStatus);
    // Create a copy of the current shipment details
    const updatedShipmentDetails = [...shipmentDetails];

    // Update the status at the specified index
    updatedShipmentDetails[index].status = newStatus;

    // Update the state with the new shipment details array
    setShipmentDetails(updatedShipmentDetails);
  };

  console.log("shipmentDetails", shipmentDetails);

  const [datechosen, setdatechosen] = useState();
  const [datechosento, setdatechosento] = useState();
  const [driver, setdriverchosen] = useState();

  const totalCod =
    shipmentDetails &&
    shipmentDetails
      .filter((data) => data.latestStatus?.toLowerCase() === "delivered")
      .reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

  const csvHeaders2 = [
    { label: "AWB", key: "AWB" },
    { label: "Status", key: "Status" },
    { label: "Last Transit Date", key: "LastTransitDate" },
    { label: "Last Transit Time", key: "LastTransitTime" },
    { label: "Courier", key: "Courier" },
    { label: "Shipper", key: "Shipper" },
    { label: "Consignee", key: "Consignee" },
    { label: "Pickup Location", key: "PickupLocation" },
    { label: "Ambient Count", key: "AmbientCount" },
    { label: "Ambient Temp", key: "AmbientTemperature" },
    { label: "Chilled Count", key: "ChilledCount" },
    { label: "Chilled Temp", key: "ChilledTemperature" },
    { label: "Frozen Count", key: "FrozenCount" },
    { label: "Frozen Temp", key: "FrozenTemperature" },
    { label: "Handover by", key: "HandoverBy" },
    { label: "Payment Type", key: "PaymentType" },
    { label: "COD", key: "COD" },
    { label: "Updated By", key: "UpdatedBy" },
  ];

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  function editStatus(orderid, codamt) {
    const collectedValue = actualCollectedMap[orderid];
    // alert(`Order ID: ${orderid}\n cod :${codamt} Actual Collected: ₹${collectedValue ?? 'Not entered'} ${driver}`);

    axios
      .post(`${API_URL}shypvdriverapp/jobs/reconcileCod`, {
        bookingId: orderid,
        codAmount: codamt,
        codCollectedAmount: collectedValue,
        driverId: driver,
      })
      .then((res) => {
        console.log(res.data);

        if (res.data.success && res.data.data?.status === "SUCCESS") {
          setSuccessMessage(
            `Successfully reconciled. Difference: AED ${res.data.data.difference}`
          );
          setErrorMessage(""); // Clear any previous errors
        } else {
          setErrorMessage("Failed to reconcile. Please try again.");
          setSuccessMessage("");
        }
        // You can update your state here if needed
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage("An error occurred while reconciling.");
        setSuccessMessage("");
      });
  }

  const [actualCollectedMap, setActualCollectedMap] = useState({});

  // Update actualCollectedMap when the component mounts
  useEffect(() => {
    const initialMap = {};
    shipmentDetails.forEach((item) => {
      initialMap[item.bookingId] = item.cashCollected ?? 0;
    });
    setActualCollectedMap(initialMap);
  }, [shipmentDetails]);

  // Calculate the sum of all values in actualCollectedMap
  const getTotalActualCollected = () => {
    return shipmentDetails
      .filter((data) => data.latestStatus?.toLowerCase() === "delivered")
      .reduce((sum, data) => {
        const collectedAmount = actualCollectedMap[data.bookingId];
        return sum + (collectedAmount ? parseFloat(collectedAmount) : 0); // Safely sum the values
      }, 0);
  };

  const csvData2 = shipmentDetails.map((data) => {
    const modifiedDate = data.modifiedDate || "";
    const [lastTransitDate, lastTransitTime] = modifiedDate.split(" ");

    return {
      AWB: data.jobId || "",
      Status: data.STATUS || "",
      LastTransitDate: lastTransitDate || "",
      LastTransitTime: lastTransitTime || "",
      Courier: data.driverName || "",
      CourierTeam: driverdata?.team || "",
      CourierZone: driverdata?.zone || "",
      Shipper: data.shipperContactName || "",
      Consignee: `${data.contactName || ""} - ${data.contactAddress || ""}`,
      PickupLocation: data.pickupLocation || "",
      AmbientCount: data.ambientCount || "0",
      AmbientTemperature: data.ambientTemperature || "",
      ChilledCount: data.chilledCount || "0",
      ChilledTemperature: data.chilledTemperature || "",
      FrozenCount: data.frozenCount || "0",
      FrozenTemperature: data.frozenTemperature || "",
      HandoverBy: data.handover || "",
      PaymentType: "", // No field in the data
      COD: "", // No field in the data
      UpdatedBy: data.driverName || "",
    };
  });

  const [searchQuery, setSearchQuery] = useState("");

  const filteredDrivers = Array.isArray(drivers)
    ? drivers.filter((driver) =>
        driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const driverOptions = filteredDrivers.map((driver) => ({
    value: driver.driver_id,
    // label: driver.driver_name
    label: `${driver.driver_id} - ${driver.driver_name}`,
  }));

  const handleChange = (selectedOption) => {
    setdriverchosen(selectedOption.value);
  };

  const [jobStatusTimesMap, setJobStatusTimesMap] = useState({});
  const [pdfload, setpdfload] = useState(false);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleGeneratePdf1 = async (shipmentDetails) => {
    setpdfload(true);
    const filteredAWBs = shipmentDetails
      .filter((item) => ["PICKED_UP", "DELIVERED"].includes(item.STATUS))
      .map((item) => item.jobId)
      .filter(Boolean);

    const jobStatusTimesMap = {};

    for (const awb of filteredAWBs) {
      try {
        const response = await axios.post(
          `${API_URL}shypvdriverapp/jobs/getJobDetails`,
          { awbNo: awb }
        );

        const jobStatusArray = response.data?.data || [];
        const statusMap = {};

        jobStatusArray.forEach((entry) => {
          const status = entry.status;
          const time = entry.updatedDate || null;
          if (status && time) {
            statusMap[status] = time;
          }
        });

        jobStatusTimesMap[awb] = statusMap;
      } catch (error) {
        console.error(`Failed to fetch status for ${awb}`, error);
        jobStatusTimesMap[awb] = {}; // continue safely
      }

      // Introduce 200ms delay between requests
      await delay(300);
    }

    generatePdf(shipmentDetails, jobStatusTimesMap);
  };

  const handleGeneratePdf = async (shipmentDetails) => {
    setpdfload(true);
    const filteredAWBs = Array.from(
      new Set(
        shipmentDetails
          .filter((item) => ["PICKED_UP", "DELIVERED"].includes(item.STATUS))
          .map((item) => item.jobId)
          .filter(Boolean)
      )
    );

    const jobStatusTimesMap = {};

    const fleetId = 80;
    const bookingIdsParam = filteredAWBs.join(","); // e.g., "UB72-25A8066_1_test,UB72-25A7875_1_test,..."

    const baseApiUrl = getApiBaseUrl();

    try {
      const response = await axios.get(
        `${baseApiUrl}/shypv/order/task/status/Allhistory`,
        {
          params: {
            bookingIds: bookingIdsParam,
          },
        }
      );

      console.log("all history: ", response.data);
      const data = response.data?.data || [];

      data.forEach((entry) => {
        const awb = entry.bookingId;
        const status = entry.typ;
        const time = entry.dt || null;

        if (!jobStatusTimesMap[awb]) {
          jobStatusTimesMap[awb] = {};
        }

        if (status && time) {
          jobStatusTimesMap[awb][status] = time;
        }
      });

      console.log("jobStatusTimesMap:", jobStatusTimesMap);
      // ✅ Now jobStatusTimesMap is ready and has the same structure as before
    } catch (error) {
      console.error("Failed to fetch bulk status:", error);
    }

    await delay(300);
    generatePdf(shipmentDetails, jobStatusTimesMap);
  };
  const generatePdf = (shipmentDetails, jobStatusTimesMap) => {
    const grouped = {};
    let grandTotalSamples = 0;
    let isFirstGroup = true;

    shipmentDetails.forEach((data, index) => {
      const [date] = (data.modifiedDate || "").split(" ");
      const key = `${date}`;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push({ index: index + 1, ...data });
    });

    const content = [];

    for (const [key, shipments] of Object.entries(grouped)) {
      const date = key;
      const courier = shipments[0]?.driverName || "--";
      const area = shipments[0]?.contactAddress || "Unknown Area";

      let ambientTotal = 0,
        chilledTotal = 0,
        frozenTotal = 0;

      const tableBody = [
        [
          { text: "No", rowSpan: 2, style: "tableHeader" },
          { text: "AWB", rowSpan: 2, style: "tableHeader" },
          { text: "Shipper", rowSpan: 2, style: "tableHeader" },
          { text: "Consignee", rowSpan: 2, style: "tableHeader" },
          { text: "Dest", rowSpan: 2, style: "tableHeader" },
          { text: "Last Modified Time", rowSpan: 2, style: "tableHeader" },
          { text: "Pickup Time", rowSpan: 2, style: "tableHeader" },
          { text: "Delivery Time", rowSpan: 2, style: "tableHeader" },
          { text: "Status", rowSpan: 2, style: "tableHeader" },
          { text: "Received by", rowSpan: 2, style: "tableHeader" },
          { text: "PC", rowSpan: 2, style: "tableHeader" },
          {
            text: "Samples",
            colSpan: 3,
            style: "tableHeader",
            alignment: "center",
          },
          {},
          {},
          { text: "Total", rowSpan: 2, style: "tableHeader" }, // ✅ Final total column
        ],
        [
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          { text: "Ambient", style: "tableSubHeader" },
          { text: "Chilled", style: "tableSubHeader" },
          { text: "Frozen", style: "tableSubHeader" },
          { text: "Total", style: "tableSubHeader" },
        ],
      ];

      shipments.forEach((data, i) => {
        const time = data.modifiedDate || "-- --";
        const ambient = parseInt(data.ambientCount || 0) || 0;
        const chilled = parseInt(data.chilledCount || 0) || 0;
        const frozen = parseInt(data.frozenCount || 0) || 0;
        const totalSamples = ambient + chilled + frozen;

        ambientTotal += ambient;
        chilledTotal += chilled;
        frozenTotal += frozen;

        const sampleCell = (count, temp) => ({
          stack: [
            { text: count.toString(), alignment: "center" },
            {
              text: `temp - ${temp || "--"}`,
              fontSize: 7,
              italics: true,
              alignment: "center",
            },
          ],
        });

        const awb = data.jobId;
        const statusMap = jobStatusTimesMap[awb] || {};
        const pickupTime = statusMap.PICKED_UP || "--";
        const deliveryTime = statusMap.DELIVERED || "--";

        tableBody.push([
          i + 1,
          data.jobId || "--",
          data.shipperContactName || "--",
          `${data.contactName || ""} - ${data.contactAddress || ""}`,
          data.contactAddress || "--",
          time || "--",
          pickupTime,
          deliveryTime,
          data.STATUS || "--",
          data.receiverName || "--",
          data.hand || "--",
          sampleCell(ambient, data.ambientTemperature),
          sampleCell(chilled, data.chilledTemperature),
          sampleCell(frozen, data.frozenTemperature),
          { text: totalSamples.toString(), alignment: "center" },
        ]);
      });

      const totalAllSamples = ambientTotal + chilledTotal + frozenTotal;
      grandTotalSamples += totalAllSamples;

      // ✅ Total row
      tableBody.push([
        { text: "Total", colSpan: 11, alignment: "right", bold: true },
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        { text: ambientTotal.toString(), alignment: "center", bold: true },
        { text: chilledTotal.toString(), alignment: "center", bold: true },
        { text: frozenTotal.toString(), alignment: "center", bold: true },
        { text: totalAllSamples.toString(), alignment: "center", bold: true },
      ]);

      if (isFirstGroup) {
        content.push(
          {
            text: "TIME EXPRESS PARCELS DELIVERY LLC",
            style: "header",
            alignment: "center",
            margin: [0, 0, 0, 5],
          },
          {
            text: `Total Consignments Pickupdate from ${datechosen} to ${datechosento} by ${courier}`,
            style: "subheader",
            alignment: "center",
            margin: [0, 0, 0, 10],
          }
        );
        isFirstGroup = false;
      }

      content.push(
        {
          columns: [
            { text: `Courier: ${courier}`, style: "subheader" },
            {
              text: `Pickup Date: ${date}`,
              style: "subheader",
              alignment: "center",
            },
            { text: `Area: ${area}`, style: "subheader", alignment: "right" },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: `Total Consignments on ${date} by ${courier}`,
          alignment: "center",
          style: "subheader",
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            headerRows: 2,
            widths: [
              20,
              65,
              45,
              50,
              40,
              30,
              50,
              50,
              50,
              40,
              20,
              30,
              30,
              30,
              25,
              25, // ✅ updated widths
            ],
            body: tableBody,
          },
          layout: "lightHorizontalLines",
          fontSize: 8,
          margin: [0, 0, 0, 20],
        }
      );
    }

    content.push({
      text: `Grand Total Samples: ${grandTotalSamples}`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 20, 10],
      fontSize: 10,
    });

    const docDefinition = {
      content,
      pageSize: "A4",
      pageOrientation: "landscape",
      styles: {
        header: { fontSize: 14, bold: true },
        subheader: { fontSize: 10, bold: true },
        tableHeader: { bold: true, fillColor: "#eeeeee", alignment: "center" },
        tableSubHeader: { bold: true, alignment: "center" },
      },
    };

    pdfMake.createPdf(docDefinition).getBlob((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const newWindow = window.open(blobUrl);

      if (!newWindow) {
        alert("Popup blocked! Please allow popups for this site.");
      }
      setpdfload(false);
    });
  };

  const [JobIDDetails, setJobIDDetails] = useState({
    pickup_time: "",
    delivery_time: "",
  });

  console.log("jobStatusTimesMap", jobStatusTimesMap);
  function getDetailsJobID(awb) {
    const payload = { awbNo: awb };

    axios
      .post(`${API_URL}shypvdriverapp/jobs/getJobDetails`, payload)
      .then((response) => {
        if (!response.data.success || !response.data.data?.length) {
          console.warn(`No data for ${awb}`, response.data);
          return; // ❌ Don't store anything
        }
        const jobStatusArray = response.data?.data || [];

        // Build a status-to-time map
        const statusTimeMap = {};

        jobStatusArray.forEach((entry) => {
          const status = entry.status;
          const time = entry.updatedDate || null;
          console.log("sttus is:", status);
          console.log("tine is:", time);
          if (status && time) {
            // Always store the latest time for a status (if multiple exist)
            statusTimeMap[status] = time;
          }
        });

        // Save into state with AWB as key
        setJobStatusTimesMap((prev) => ({
          ...prev,
          [awb]: statusTimeMap,
        }));
      })
      .catch((error) => {
        console.error("Error fetching job ID details:", error);
      });
  }

  return (
    <div>
      <div className="form-container">
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="driver">From Date:</label>
              <input
                type="date"
                id="date"
                value={datechosen}
                onChange={(e) => setdatechosen(e.target.value)}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="driver">To Date:</label>
              <input
                type="date"
                id="date"
                value={datechosento}
                onChange={(e) => setdatechosento(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          {/* Driver Selection */}
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="driver">Select Driver:</label>
              <Select
                options={driverOptions}
                value={driverOptions.find(
                  (option) => option.value === scaninfo.driver
                )}
                onChange={handleChange}
                placeholder="Select a driver"
                onInputChange={(newValue) => setSearchQuery(newValue)} // Update search query
                isSearchable
                noOptionsMessage={() => "No drivers found"}
              />
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <a
                  onClick={getDetails}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Submit
                </a>
              </div>
            </div>
            <p style={{ color: "red", marginTop: "2%" }}>{errormsg}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-11">
            {loading && <p>Loading shipment details...</p>}
            {successMessage && (
              <div style={{ color: "green" }}>{successMessage}</div>
            )}
            {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}

            {shipmentDetails.length > 0 && (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginBottom: "10px",
                    alignItems: "baseline", // Align children on their baseline (buttons align horizontally)
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      flexShrink: 0,
                      width: "150px",
                    }}
                  >
                    <a
                      onClick={() => handleGeneratePdf(shipmentDetails)}
                      className="btn btn-secondary"
                      style={{
                        fontSize: "17px",
                        cursor: "pointer",
                        background: "#fff",
                        color: "#337ab7",
                        border: "1px solid #337ab7",
                        marginRight: "5%",
                      }}
                    >
                      <i
                        className="fa fa-file-pdf-o"
                        style={{ marginRight: "5px" }}
                      ></i>{" "}
                      Generate PDF
                    </a>
                    <p style={{ margin: "5px 0 0 0" }}>
                      {" "}
                      {pdfload ? "loading..." : ""}
                    </p>
                  </div>

                  <CSVLink
                    headers={csvHeaders2}
                    data={csvData2}
                    filename="driver_shipment_summary.csv"
                    className="btn btn-primary"
                    style={{ fontSize: "17px", flexShrink: 0 }}
                  >
                    <i
                      className="fa fa-download"
                      style={{ marginRight: "5px" }}
                    ></i>{" "}
                    Download CSV
                  </CSVLink>
                </div>

                <h4 style={{ textAlign: "left" }}>Track Summary:</h4>

                <div
                  className="shipdata"
                  style={{
                    background: "#5583af59",
                    maxHeight: "500px", // Adjust the height limit as needed
                    overflowY: "auto", // Enables vertical scrolling
                    // padding: '10px',   // Optional: Add some padding for better visuals
                    border: "1px solid #ccc", // Optional: Add a border for separation
                    // marginBottom:'3%'
                  }}
                >
                  <table className="table  table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>AWB</th>
                        <th>Status</th>
                        <th>Last Transit Date</th>
                        <th>Last Transit Time</th>
                        <th>Courier</th>
                        <th>Shipper</th>
                        <th>Consignee</th>
                        <th>Pickup Location</th>
                        <th>Ambient Count</th>
                        <th>Ambient Temp</th>
                        <th>Chilled Count</th>
                        <th>Chilled Temp</th>
                        <th>Frozen Count</th>
                        <th>Frozen Temp</th>
                        <th>Handover by</th>
                        <th>Received by</th>

                        {/* <th>Picked_Up Time</th>
                        <th>Delivered time</th> */}
                        <th>Updated By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shipmentDetails.map((data, index) => {
                        const modifiedDate = data.modifiedDate || ""; // "2025-08-01 08:48:12"
                        const [lastTransitDate, lastTransitTime] =
                          modifiedDate.split(" ");
                        // const jobId = data.jobId;
                        //   const statusTimes = jobStatusTimesMap[jobId] || {};
                        return (
                          <tr key={index}>
                            <td>{data.jobId || "--"}</td> {/* AWB */}
                            <td>{data.STATUS || "--"}</td> {/* Status */}
                            <td>{lastTransitDate || "--"}</td>{" "}
                            {/* Last Transit Date */}
                            <td>{lastTransitTime || "--"}</td>{" "}
                            {/* Last Transit Time */}
                            <td>{data.driverName || "--"}</td> {/* Courier */}
                            {/* <td>--</td> */} {/* Courier Team (optional) */}
                            {/* <td>--</td> */} {/* Courier Zone (optional) */}
                            <td>{data.shipperContactName || "--"}</td>{" "}
                            {/* Shipper */}
                            <td>
                              {`${data.contactName || ""} - ${
                                data.contactAddress || ""
                              }` || "--"}
                            </td>
                            <td>{data.pickupLocation || "--"}</td>{" "}
                            {/* Pickup Location */}
                            <td>{data.ambientCount || "0"}</td>{" "}
                            {/* Ambient Count */}
                            <td>{data.ambientTemperature || "--"}</td>{" "}
                            {/* Ambient Temp */}
                            <td>{data.chilledCount || "0"}</td>{" "}
                            {/* Chilled Count */}
                            <td>{data.chilledTemperature || "--"}</td>{" "}
                            {/* Chilled Temp */}
                            <td>{data.frozenCount || "0"}</td>{" "}
                            {/* Frozen Count */}
                            <td>{data.frozenTemperature || "--"}</td>{" "}
                            {/* Frozen Temp */}
                            <td>{data.handoverName || "--"}</td>{" "}
                            {/* Handover by */}
                            <td>{data.receiverName || "--"}</td>{" "}
                            {/* Handover by */}
                            {/* <td>{statusTimes.PICKED_UP || "--"}</td>
        <td>{statusTimes.DELIVERED || "--"}</td> */}
                            <td>
                              {data.updated_by
                                ? data.updated_by
                                : data.driverName}
                            </td>{" "}
                            {/* Updated By */}
                            {/* Extra column if needed */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
